import { jsx as _jsx } from "react/jsx-runtime";
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
const SidebarTeamInviteButton = Dynamic(async () => {
    const { SidebarTeamInviteButton } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarTeamInviteButton.js');
    return { default: SidebarTeamInviteButton };
});
const SidebarInviteButton = Dynamic(async () => {
    const { SidebarInviteButton } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarInviteButton.js');
    return { default: SidebarInviteButton };
});
const SidebarEnterpriseInviteButton = Dynamic(async () => {
    const { SidebarEnterpriseInviteButton } = await import('#pplx/frontend/apps/ask/layout-aux/sidebar-bottom/SidebarEnterpriseInviteButton.js');
    return { default: SidebarEnterpriseInviteButton };
});
export function SidebarInvite({ kind, presentation }) {
    switch (kind) {
        case 'team-upsell':
            return _jsx(SidebarTeamInviteButton, { isExpanded: presentation === 'expanded' });
        case 'org-members':
            return presentation === 'expanded' ? (_jsx(SidebarEnterpriseInviteButton, {})) : (_jsx(SidebarInviteButton, { variant: presentation === 'accessory' ? 'accessory' : 'sidebar' }));
        default:
            return assertUnreachableValue(kind);
    }
}
//# sourceMappingURL=SidebarInvite.js.map